import { FontAwesomeSvgIcon as FontAwesomeIcon } from 'react-fontawesome-svg-icon'

import { faCrown } from '@fortawesome/pro-solid-svg-icons'

import { ServiceTier } from '@infura/packages.api'
import { FEATURE_FLAGS } from '@infura/packages.common/constants'
import { trackClickForSegmentAnalytics } from '@infura/packages.common/segmentAnalytics'
import { getUserSubscriptionTier } from '@infura/packages.common/user'
import { Button } from '@infura/packages.ui/Button'

import FeatureToggle from 'components/FeatureToggle'

import { useUKSServicePlan } from 'hooks/useUKSServicePlan'

import { BILLING_PLAN_ROUTE } from 'lib/constants'

export const UpgradeButton = () => {
  const { servicePlan } = useUKSServicePlan()

  return (
    <FeatureToggle flag={FEATURE_FLAGS.NEW_API_KEY_POLICY_ENABLED} waitUntilFlagReady>
      {!!servicePlan && getUserSubscriptionTier(servicePlan) === ServiceTier.CORE ? (
        <div className='ml-1 flex pb-2 pr-3 pt-1'>
          <Button
            className='flex justify-between'
            data-testid='header-upgrade-plan'
            fullWidth
            href={BILLING_PLAN_ROUTE}
            onClick={() => {
              trackClickForSegmentAnalytics({
                clickText: 'Upgrade',
                clickUrl: BILLING_PLAN_ROUTE,
                location: 'Header',
                type: 'Text'
              })
            }}
          >
            <div className='flex w-full items-center justify-center'>
              <FontAwesomeIcon className='mb-0.5 mr-2 p-[3px] text-[10px]' icon={faCrown} />
              <span>Upgrade</span>
            </div>
          </Button>
        </div>
      ) : undefined}
    </FeatureToggle>
  )
}
